import log from "./log";

function AjaxError(req) {
	const { status, statusText } = req;
	// log(__filename, status, "error");
	log(__filename, statusText, "error");
}

export default AjaxError;
